<template>
  <div style="color:#6c757d !important;">
    <!-- ----------------------------------- -->
    <!-- navbar starts -->
    <vs-navbar
      v-model="indexActive"
      :color="colorx"
      text-color="rgba(255,255,255,.6)"
      active-text-color="rgba(255,255,255,1)"
      class="myNavbar"
    >
      <div slot="title">
        <vs-navbar-title>Graphs Presentations</vs-navbar-title>
      </div>
    </vs-navbar>
    <!-- navbar ends -->
    <!-- ----------------------------------- -->
    <!-- container starts -->
    <div class="container mt-5">
      <div class="row">
        <div class="col-sm-12 p-0 print-scr">
          <span class="btn btn-primary float-right btn-sm print-btn" @click="printReport">
            <i class="material-icons">print</i> Print
          </span>
          <vs-breadcrumb
            align="left"
            :items="
                  [
                   {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Advisor/advisordashboard'
                    },
                    {
                      title: 'Reports',
                      url: '/#/dashboard/Admin/graphs',
                      active: true
                    }
                  ]"
          ></vs-breadcrumb>
        </div>
      </div>
    </div>
    <div class="container container-bdr mt-2 mb-5">
      <!-- row starts -->
      <div class="row">
        <!-- col-md starts -->
        <div class="col-md-6 mb-3 pl-0">
          <div class="grapgh-box">
            <p class="mt-2 mb-2">
              <span>
                <strong class="title">Month Wise Assigned Trainings (By M & E)</strong>
                <hr class="line-bordered" />
                <div class="row print-scr">
                  <div class="col-sm-12 mt-0">
                    <strong class="title">Filter By</strong>
                    <table class="table">
                      <tbody class="line-bordered">
                        <tr class="sm-screen">
                          <td>
                            <selectize v-model="selectedOfficer" :settings="officerSetting">
                              <!-- settings is optional -->
                              <option
                                v-for="(item,index) in officerArr"
                                :key="index"
                                :value="item.id"
                                :text="item.name"
                              >{{item.name}}</option>
                            </selectize>
                          </td>

                          <td>
                            <selectize v-model="officerTopic" :settings="topicSettingOfficer">
                              <!-- settings is optional -->
                              <option value="training">Trainings</option>
                              <option value="fundingAgency">Funding Agency</option>
                              <option value="thematicArea">Thematic Area</option>
                              <option value="project">Project</option>
                              <option value="subProgram">Subprogram</option>
                              <option value="department">Department</option>
                            </selectize>
                          </td>
                        </tr>
                        <tr class="sm-screen">
                          <td colspan="2">
                            <selectize v-model="startDateOfficer" :settings="startDateSetting">
                              <option
                                v-for="(item,index) in yearArr"
                                :key="index"
                                :value="item.id"
                                :text="item.value"
                                class="text-capitalize"
                              >{{item.value}}</option>
                            </selectize>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </span>
            </p>
            <div class="line-bordered col-sm-8 offset-sm-2" style="background:#f9f9f9">
              <canvas id="bar-chart" width="400" height="400"></canvas>
            </div>
          </div>
        </div>
        <!-- col-md ends -->
        <!-- col-md starts -->
        <div class="col-md-6 mb-3 pl-0">
          <div class="grapgh-box" style="height:507px">
            <p class="mt-2">
              <span>
                <strong class="title">Assigned Trainings to Advisor</strong>
                <hr class="line-bordered" />
              </span>
            </p>
            <div
              class="line-bordered col-sm-8 offset-sm-2"
              style="background:#f9f9f9;margin-top:70px !important"
            >
              <canvas class="chart-container" id="myChart" width="400" height="400"></canvas>
            </div>
          </div>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->

        <div class="col-md-6 mb-3 pl-0">
          <div class="grapgh-box">
            <p class="mt-2 mb-2">
              <span>
                <strong class="title">In Queue Trainings</strong>
                <hr class="line-bordered" />
                <div class="row print-scr">
                  <div class="col-sm-12 mt-0">
                    <strong class="title">Filter By</strong>
                    <table class="table">
                      <tbody class="line-bordered">
                        <tr class="sm-screen">
                          <td>
                            <selectize v-model="selectedOfficerQue" :settings="officerSetting">
                              <!-- settings is optional -->
                              <option
                                v-for="(item,index) in officerArr"
                                :key="index"
                                :value="item.id"
                                :text="item.name"
                              >{{item.name}}</option>
                            </selectize>
                          </td>
                          <td>
                            <selectize v-model="startDateOfficerQue" :settings="startDateSetting">
                              <option
                                v-for="(item,index) in yearArr"
                                :key="index"
                                :value="item.id"
                                :text="item.value"
                                class="text-capitalize"
                              >{{item.value}}</option>
                            </selectize>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </span>
            </p>
            <div class="line-bordered col-sm-8 offset-sm-2" style="background:#f9f9f9">
              <canvas id="bar-chart-grouped-2" width="400" height="400"></canvas>
            </div>
          </div>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->

        <!-- col-md starts -->
        <div class="col-md-6 mb-3 pl-0">
          <div class="grapgh-box">
            <p class="mt-2 mb-2">
              <span>
                <strong class="title">In Progress Trainings</strong>
                <hr class="line-bordered" />
                <div class="row print-scr">
                  <div class="col-sm-12 mt-0">
                    <strong class="title">Filter By</strong>
                    <table class="table">
                      <tbody class="line-bordered">
                        <tr class="sm-screen"></tr>
                        <tr class="sm-screen">
                          <td>
                            <selectize v-model="selectedOfficerProgress" :settings="officerSetting">
                              <!-- settings is optional -->
                              <option
                                v-for="(item,index) in officerArr"
                                :key="index"
                                :value="item.id"
                                :text="item.name"
                              >{{item.name}}</option>
                            </selectize>
                          </td>
                          <td>
                            <selectize
                              v-model="startDateOfficerProgress"
                              :settings="startDateSetting"
                            >
                              <option
                                v-for="(item,index) in yearArr"
                                :key="index"
                                :value="item.id"
                                :text="item.value"
                                class="text-capitalize"
                              >{{item.value}}</option>
                            </selectize>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </span>
            </p>
            <div class="line-bordered col-sm-8 offset-sm-2" style="background:#f9f9f9">
              <canvas id="bar-chart-grouped-3" width="400" height="400"></canvas>
            </div>
          </div>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
      </div>
      <!-- row ends -->
    </div>
    <!-- container ends -->
  </div>
</template>

<script>
import Chart from "chart.js";
import Selectize from "vue2-selectize";
import axios from "axios";
// flatPickr
import "flatpickr/dist/flatpickr.css";

export default {
  data: () => ({
    colorx: "#2196f3",
    basepath: process.env.VUE_APP_BASE_PATH,
    indexActive: 0,
    monthWiseAssignedME: [],
    InQueueTraining: [],
    InProgressTraining: [],
    AllTraining: [],
    allAssignedTraining: 0,
    InQueueTrainingME: 0,
    InProgressTrainingME: 0,
    selected: 1,
    dateRange: [],
    dateOptions: {
      wrap: true,
      dateFormat: "d-m-Y"
    },
    yearArr: [],
    // start officer
    selectedOfficer: "",
    officerTopic: "",
    topicSettingOfficer: {
      delimiter: "|",
      placeholder: "Select Topic"
    },
    startDateSetting: {
      delimiter: "|",
      placeholder: "Select Year"
    },
    startDateOfficer: "",
    officerArr: [],
    officerSetting: {
      maxItems: 1,
      searchField: ["text"],
      placeholder: "Select program officer here"
    },
    // end officer
    // start in queue
    selectedOfficerQue: "",
    startDateOfficerQue: "",
    // end officer Queue

    // start in progress
    selectedOfficerProgress: "",
    startDateOfficerProgress: "",
    // end officer progress

    officerChart: "",
    queChart: "",
    progressChart: ""
  }),
  watch: {
    // officer
    selectedOfficer() {
      this.showOfficerGraph();
    },
    officerTopic() {
      this.showOfficerGraph();
    },
    startDateOfficer() {
      this.showOfficerGraph();
    },
    // --officer
    // que taraining
    selectedOfficerQue() {
      this.showOfficerQueGraph();
    },
    startDateOfficerQue() {
      this.showOfficerQueGraph();
    },
    // --officer Que
    // progress taraining
    selectedOfficerProgress() {
      this.showOfficerProgressGraph();
    },
    startDateOfficerProgress() {
      this.showOfficerProgressGraph();
    }
    // --progress officer
  },
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.showOfficerGraphOnload();
    this.showOfficerQueGraphOnload();
    this.showOfficerProgressGraphOnload();
    this.showYear();
    this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/filter/programofficer/get/"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.officerArr = response.data;
      });
    this.openLoading();
    axios
      .get(
        process.env.VUE_APP_BASE_PATH +
          "/monthwise/advisor/total/training/get/" +
          JSON.parse(localStorage.getItem("currentUser")).id
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        if (response.data) {
          this.AllTraining = response.data;
          this.allAssignedTraining = this.AllTraining.length;
          this.AllTraining.forEach(element => {
            if (element.trainingstatus == "In Queue") {
              this.InQueueTrainingME++;
            }
            if (element.trainingstatus == "In Progress") {
              this.InProgressTrainingME++;
            }
          });
          new Chart(document.getElementById("myChart"), {
            type: "pie",
            data: {
              labels: [
                "Assigned By M&E",
                "In Queue Trainings",
                "In Progress Trainings"
              ],
              datasets: [
                {
                  backgroundColor: ["#e74c3c", "#3498db", "#95a5a6"],
                  data: [
                    this.allAssignedTraining,
                    this.InQueueTrainingME,
                    this.InProgressTrainingME
                  ]
                }
                // {
                //   label: "No. of Trainings",
                //   data: [
                //     this.allAssignedTraining,
                //     this.InQueueTrainingME,
                //     this.InProgressTrainingME
                //   ],
                //   backgroundColor: ["#e74c3c", "#3498db", "#95a5a6"]
                // }
              ]
            }
          });
        }
      });

    // chart 5 ends
  },
  methods: {
    showOfficerGraphOnload: function showOfficerGraphOnload() {
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/monthwise/advisor/assigned/training/get/" +
            JSON.parse(localStorage.getItem("currentUser")).id
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data) {
            this.monthWiseAssignedME = response.data;
            this.officerChart = new Chart(
              document.getElementById("bar-chart"),
              {
                type: "bar",
                data: {
                  labels: [" "],
                  datasets: [
                    {
                      label: "No of training's",
                      backgroundColor: "#f1c40f",
                      data: [
                        this.monthWiseAssignedME[0],
                        this.monthWiseAssignedME[1],
                        this.monthWiseAssignedME[2],
                        this.monthWiseAssignedME[3],
                        this.monthWiseAssignedME[4],
                        this.monthWiseAssignedME[5],
                        this.monthWiseAssignedME[6],
                        this.monthWiseAssignedME[7],
                        this.monthWiseAssignedME[8],
                        this.monthWiseAssignedME[9],
                        this.monthWiseAssignedME[10],
                        this.monthWiseAssignedME[11],
                        this.monthWiseAssignedME[12]
                      ]
                    }
                  ]
                },
                options: {
                  scales: {
                    xAxes: [
                      {
                        type: "category",
                        labels: [
                          "Jan",
                          "Feb",
                          "Mar",
                          "Apr",
                          "May",
                          "Jun",
                          "Jul",
                          "Aug",
                          "Sep",
                          "Oct",
                          "Nov",
                          "Dec"
                        ]
                      }
                    ],
                    yAxes: [
                      {
                        ticks: {
                          min: 0,
                          max: 50,
                          callback: function(value) {
                            return value + " ";
                          }
                        },
                        scaleLabel: {
                          display: true,
                          labelString: "No. of Trainings"
                        }
                      }
                    ]
                  }
                }
              }
            );
          }
        });
      // total trainings
    },
    // this will show onload onqueue tarining
    showOfficerQueGraphOnload: function showOfficerQueGraphOnload() {
      // IN QUEUE Trainings
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/monthwise/advisor/InQueue/training/get/" +
            JSON.parse(localStorage.getItem("currentUser")).id
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data) {
            this.InQueueTraining = response.data;
            this.queChart = new Chart(
              document.getElementById("bar-chart-grouped-2"),
              {
                type: "bar",
                data: {
                  labels: [" "],
                  datasets: [
                    {
                      label: "In Queue Training's",
                      backgroundColor: "#2ecc71",
                      data: [
                        this.InQueueTraining[0],
                        this.InQueueTraining[1],
                        this.InQueueTraining[2],
                        this.InQueueTraining[3],
                        this.InQueueTraining[4],
                        this.InQueueTraining[5],
                        this.InQueueTraining[6],
                        this.InQueueTraining[7],
                        this.InQueueTraining[8],
                        this.InQueueTraining[9],
                        this.InQueueTraining[10],
                        this.InQueueTraining[11],
                        this.InQueueTraining[12]
                      ]
                    }
                  ]
                },
                options: {
                  scales: {
                    xAxes: [
                      {
                        type: "category",
                        labels: [
                          "Jan",
                          "Feb",
                          "Mar",
                          "Apr",
                          "May",
                          "Jun",
                          "Jul",
                          "Aug",
                          "Sep",
                          "Oct",
                          "Nov",
                          "Dec"
                        ]
                      }
                    ],
                    yAxes: [
                      {
                        ticks: {
                          min: 0,
                          max: 50,
                          callback: function(value) {
                            return value + " ";
                          }
                        },
                        scaleLabel: {
                          display: true,
                          labelString: "No. of Trainings"
                        }
                      }
                    ]
                  }
                }
              }
            );
          }
        });
    },
    showOfficerProgressGraphOnload: function showOfficerProgressGraphOnload() {
      // In Progress Trainings
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/monthwise/advisor/InProgress/training/get/" +
            JSON.parse(localStorage.getItem("currentUser")).id
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data) {
            this.InProgressTraining = response.data;
            this.progressChart = new Chart(
              document.getElementById("bar-chart-grouped-3"),
              {
                type: "bar",
                data: {
                  labels: [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                  ],
                  datasets: [
                    {
                      label: "In Progress Training's",
                      backgroundColor: "#3498db",
                      data: [
                        this.InProgressTraining[0],
                        this.InProgressTraining[1],
                        this.InProgressTraining[2],
                        this.InProgressTraining[3],
                        this.InProgressTraining[4],
                        this.InProgressTraining[5],
                        this.InProgressTraining[6],
                        this.InProgressTraining[7],
                        this.InProgressTraining[8],
                        this.InProgressTraining[9],
                        this.InProgressTraining[10],
                        this.InProgressTraining[11],
                        this.InProgressTraining[12]
                      ]
                    }
                  ]
                },
                options: {
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          min: 0,
                          max: 50,
                          callback: function(value) {
                            return value + " ";
                          }
                        },
                        scaleLabel: {
                          display: true,
                          labelString: "No. of Trainings"
                        }
                      }
                    ]
                  }
                }
              }
            );
          }
        });
    },
    // this will show officer graph on filter
    showOfficerGraph: function showOfficerGraph() {
      if (
        this.selectedOfficer != "" &&
        this.officerTopic != "" &&
        this.startDateOfficer != ""
      ) {
        this.openLoading();
        axios
          .get(
            process.env.VUE_APP_BASE_PATH +
              "/advisor/" +
              JSON.parse(localStorage.getItem("currentUser")).id +
              "/reports/officer/" +
              this.selectedOfficer +
              "/" +
              this.officerTopic +
              "/" +
              this.startDateOfficer +
              "/get"
          )
          .then(response => {
            this.closeLoading();
            this.dataOfficer = [];
            if (response.data) {
              setTimeout(() => {
                response.data.forEach((item) => {
                  if (item.months == 1) {
                    this.dataOfficer[0] = item.trngCount;
                  } else if (item.months == 2) {
                    this.dataOfficer[1] = item.trngCount;
                  } else if (item.months == 3) {
                    this.dataOfficer[2] = item.trngCount;
                  } else if (item.months == 4) {
                    this.dataOfficer[3] = item.trngCount;
                  } else if (item.months == 5) {
                    this.dataOfficer[4] = item.trngCount;
                  } else if (item.months == 6) {
                    this.dataOfficer[5] = item.trngCount;
                  } else if (item.months == 7) {
                    this.dataOfficer[6] = item.trngCount;
                  } else if (item.months == 8) {
                    this.dataOfficer[7] = item.trngCount;
                  } else if (item.months == 9) {
                    this.dataOfficer[8] = item.trngCount;
                  } else if (item.months == 10) {
                    this.dataOfficer[9] = item.trngCount;
                  } else if (item.months == 11) {
                    this.dataOfficer[10] = item.trngCount;
                  } else if (item.months == 12) {
                    this.dataOfficer[11] = item.trngCount;
                  }
                });

                // chart 1 starts
                this.officerChart.destroy();
                this.officerChart = new Chart(
                  document.getElementById("bar-chart"),
                  {
                    type: "bar",
                    data: {
                      labels: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                      ],
                      datasets: [
                        {
                          label: this.officerTopic,
                          backgroundColor: "#f1c40f",
                          data: this.dataOfficer
                        }
                      ]
                    },
                    options: {
                      scales: {
                        yAxes: [
                          {
                            ticks: {
                              min: 0,
                              max: 50,
                              callback: function(value) {
                                return value + " ";
                              }
                            },
                            scaleLabel: {
                              display: true,
                              labelString: this.officerTopic
                            }
                          }
                        ]
                      }
                    }
                  }
                );
                // chart 1 ends
              });
            }
          });
      }
    },
    // this will show officer graph inqueue on filter
    showOfficerQueGraph: function showOfficerQueGraph() {
      if (this.selectedOfficerQue != "" && this.startDateOfficerQue != "") {
        this.openLoading();
        axios
          .get(
            process.env.VUE_APP_BASE_PATH +
              "/advisor/reports/officer/" +
              JSON.parse(localStorage.getItem("currentUser")).id +
              "/" +
              this.selectedOfficerQue +
              "/" +
              this.startDateOfficerQue +
              "/inqueue/get"
          )
          .then(response => {
            this.closeLoading();
            this.dataOfficerQue = [];
            if (response.data) {
              setTimeout(() => {
                response.data.forEach((item) => {
                  if (item.months == 1) {
                    this.dataOfficerQue[0] = item.trngCount;
                  } else if (item.months == 2) {
                    this.dataOfficerQue[1] = item.trngCount;
                  } else if (item.months == 3) {
                    this.dataOfficerQue[2] = item.trngCount;
                  } else if (item.months == 4) {
                    this.dataOfficerQue[3] = item.trngCount;
                  } else if (item.months == 5) {
                    this.dataOfficerQue[4] = item.trngCount;
                  } else if (item.months == 6) {
                    this.dataOfficerQue[5] = item.trngCount;
                  } else if (item.months == 7) {
                    this.dataOfficerQue[6] = item.trngCount;
                  } else if (item.months == 8) {
                    this.dataOfficerQue[7] = item.trngCount;
                  } else if (item.months == 9) {
                    this.dataOfficerQue[8] = item.trngCount;
                  } else if (item.months == 10) {
                    this.dataOfficerQue[9] = item.trngCount;
                  } else if (item.months == 11) {
                    this.dataOfficerQue[10] = item.trngCount;
                  } else if (item.months == 12) {
                    this.dataOfficerQue[11] = item.trngCount;
                  }
                });

                // chart 1 starts
                this.queChart.destroy();
                this.queChart = new Chart(
                  document.getElementById("bar-chart-grouped-2"),
                  {
                    type: "bar",
                    data: {
                      labels: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                      ],
                      datasets: [
                        {
                          label: "In Queue Trainings",
                          backgroundColor: "#2ecc71",
                          data: this.dataOfficerQue
                        }
                      ]
                    },
                    options: {
                      scales: {
                        yAxes: [
                          {
                            ticks: {
                              min: 0,
                              max: 50,
                              callback: function(value) {
                                return value + " ";
                              }
                            },
                            scaleLabel: {
                              display: true,
                              labelString: "In Queue Trainings"
                            }
                          }
                        ]
                      }
                    }
                  }
                );
                // chart 1 ends
              });
            }
          });
      }
    },

    showOfficerProgressGraph: function showOfficerProgressGraph() {
      if (
        this.selectedOfficerProgress != "" &&
        this.startDateOfficerProgress != ""
      ) {
        this.openLoading();
        axios
          .get(
            process.env.VUE_APP_BASE_PATH +
              "/advisor/reports/officer/" +
              JSON.parse(localStorage.getItem("currentUser")).id +
              "/" +
              this.selectedOfficerProgress +
              "/" +
              this.startDateOfficerProgress +
              "/inprogress/get"
          )
          .then(response => {
            this.closeLoading();
            this.dataOfficerProg = [];
            if (response.data) {
              setTimeout(() => {
                response.data.forEach((item) => {
                  if (item.months == 1) {
                    this.dataOfficerProg[0] = item.trngCount;
                  } else if (item.months == 2) {
                    this.dataOfficerProg[1] = item.trngCount;
                  } else if (item.months == 3) {
                    this.dataOfficerProg[2] = item.trngCount;
                  } else if (item.months == 4) {
                    this.dataOfficerProg[3] = item.trngCount;
                  } else if (item.months == 5) {
                    this.dataOfficerProg[4] = item.trngCount;
                  } else if (item.months == 6) {
                    this.dataOfficerProg[5] = item.trngCount;
                  } else if (item.months == 7) {
                    this.dataOfficerProg[6] = item.trngCount;
                  } else if (item.months == 8) {
                    this.dataOfficerProg[7] = item.trngCount;
                  } else if (item.months == 9) {
                    this.dataOfficerProg[8] = item.trngCount;
                  } else if (item.months == 10) {
                    this.dataOfficerProg[9] = item.trngCount;
                  } else if (item.months == 11) {
                    this.dataOfficerProg[10] = item.trngCount;
                  } else if (item.months == 12) {
                    this.dataOfficerProg[11] = item.trngCount;
                  }
                });

                // chart 1 starts
                this.progressChart.destroy();
                this.progressChart = new Chart(
                  document.getElementById("bar-chart-grouped-3"),
                  {
                    type: "bar",
                    data: {
                      labels: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                      ],
                      datasets: [
                        {
                          label: "In Progress Trainings",
                          backgroundColor: "#3498db",
                          data: this.dataOfficerProg
                        }
                      ]
                    },
                    options: {
                      scales: {
                        yAxes: [
                          {
                            ticks: {
                              min: 0,
                              max: 50,
                              callback: function(value) {
                                return value + " ";
                              }
                            },
                            scaleLabel: {
                              display: true,
                              labelString: "In Progress Trainings"
                            }
                          }
                        ]
                      }
                    }
                  }
                );
                // chart 1 ends
              });
            }
          });
      }
    },
    showYear: function showYear() {
      for (var i = 0; i <= 35; i++) {
        this.yearArr.push({ id: 2015 + i, value: 2015 + i });
      }
    },
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
       
      this.$vs.loading.close();
    },
    printReport: function() {
      window.print();
    }
  },
  components: {
    Selectize,
  }
};
</script>
<style scoped>
.myNavbar {
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1), 0 5px 5px rgba(0, 0, 0, 0.1) !important;
}
.nav-route-link {
  background: none !important;
  border-right: 0px !important;
}
.grapgh-box {
  border: 3px solid #2196f3;
  padding: 10px;
}
.line-bordered {
  border: 0.5px solid #2196f36b;
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

strong.title {
  color: #2196f3;
}

tbody.bordered {
  border: 1px solid #2196f3;
}

.selectize-input {
  border: 1px solid #333 !important;
}

table .td {
  border-top: 1px solid #2196f3;
}
@media only screen and (max-width: 600px) {
  .training-width {
    width: 100% !important;
  }
  .sm-screen {
    display: grid !important;
  }
}
@media only screen and (max-width: 992px) {
  .training-width {
    width: 100% !important;
  }
  .sm-screen {
    display: grid !important;
  }
}
</style>
<style>
.vs-navbar--header {
  height: 60px;
  padding: 20px;
}
.vs-con-items {
  padding: 20px;
}
@media screen and (max-width: 800px) {
  .vs-con-items.activeMenuResponsive {
    background-color: #46637a !important;
  }
}
</style>